import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import FeaturedBlogItem from '../components/FeaturedBlogItem';

const FeaturedBlog = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allCosmicjsPosts(sort: { fields: [published_at], order: DESC }) {
            edges {
              node {
                title
                id
                slug
                content
                published_at(formatString: "DD MMMM, YYYY")
                metadata {
                  post_author {
                    title
                  }
                  tag {
                    title
                  }
                  description
                  main_image {
                    url
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <div class="bg-fadedBlue">
            <div class="pt-12 sm:pt-16 lg:pt-20">
              <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center">
                  <h2 class="text-3xl leading-9 font-extrabold text-darkRed sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none">
                    Latest from our Blog
                  </h2>
                </div>
              </div>
            </div>
            <div class="mt-8 bg-fadedBlue pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
              {data.allCosmicjsPosts.edges.slice(0, 3).map(post => {
                return (
                  <FeaturedBlogItem
                    key={post.node.id}
                    title={post.node.title}
                    date={post.node.published_at}
                    author={post.node.metadata.post_author.title}
                    description={post.node.metadata.description}
                    slug={'blog/' + post.node.slug}
                    image={post.node.metadata.main_image.url}
                    category={post.node.metadata.tag.map(tag => {
                      return (
                        <p class="-mt-2 -mb-2  leading-tight inline-block pr-2 ">
                          {tag.title + ','}
                        </p>
                      );
                    })}
                  />
                );
              })}

              <div class="mt-6 text-center">
                <a class=" text-lg underline font-medium text-blue " href="/blog">
                  View all posts
                </a>
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default FeaturedBlog;
